import React from 'react';
import PropTypes from 'prop-types';
import {
  LicenseManager,
  ModuleRegistry,
  AgChartsEnterpriseModule,
  TreemapSeriesModule,
  GradientLegendModule,
  LineSeriesModule,
  CategoryAxisModule,
  NumberAxisModule,
  TimeAxisModule,
  LegendModule,
} from 'ag-charts-enterprise';
import { AgCharts as AgChartsReact } from 'ag-charts-react';
import { AgChartsCommunityModule } from 'ag-charts-community';
import config from '../../../config';
import LoadingSpinner from '../widgets/LoadingSpinner';

// Set license key for AG Charts
LicenseManager.setLicenseKey(config.agGridKey);

// Register all AG Charts modules
ModuleRegistry.registerModules([
  AgChartsCommunityModule,
  AgChartsEnterpriseModule,
  TreemapSeriesModule,
  GradientLegendModule,
  LineSeriesModule,
  CategoryAxisModule,
  NumberAxisModule,
  TimeAxisModule,
  LegendModule,
]);

const ChartBuilder = ({
  parentRefresh,
  chartOptions,
  chartHeight,
  chartData,
}) => {
  // If chartData is provided separately, merge it into options
  let options = chartData ? { ...chartOptions, data: chartData } : chartOptions;

  // AG Charts v13 requires height in chartOptions
  // If chartHeight prop is provided but no height in options, extract numeric value
  if (chartHeight && !options.height) {
    const heightNum = parseInt(chartHeight, 10);
    if (!Number.isNaN(heightNum)) {
      options = { ...options, height: heightNum };
    }
  }

  return (
    <div style={{ height: chartHeight, width: '100%', padding: '5px' }}>
      {parentRefresh ? (
        <LoadingSpinner active={parentRefresh} wrap />
      ) : (
        <div style={{ height: '100%', width: '100%' }}>
          <AgChartsReact options={options} />
        </div>
      )}
    </div>
  );
};

ChartBuilder.propTypes = {
  parentRefresh: PropTypes.bool,
  chartOptions: PropTypes.shape().isRequired,
  chartHeight: PropTypes.string,
  chartData: PropTypes.arrayOf(PropTypes.shape()),
};

ChartBuilder.defaultProps = {
  chartHeight: '300px',
  parentRefresh: false,
  chartData: null,
};

export default ChartBuilder;
